import * as React from 'react';

interface Props {
  customLabels?: any;
  fields: Array<string>;
  select: (index: number) => void;
  values: { [key: string]: any };
  isSelected: (index: number) => boolean;
}

export default ({
  customLabels = {},
  fields,
  values,
  isSelected,
  select,
}: Props) => (
  <form className="merge-form">
    {fields.map((key, index) => (
      <div
        key={key}
        onClick={() => select(index)}
        className={isSelected(index) ? 'selected' : ''}
      >
        <small>
          {(customLabels[key] ? customLabels[key] : key).replace(/\_/g, ' ')}
        </small>
        <div className="input is-static">{values[key] || ''}</div>
      </div>
    ))}
  </form>
);
